import React from 'react';
import { Redirect, useLocalSearchParams, usePathname } from 'expo-router';
import { useAuthStore } from '@/store/auth';
import LandingPage from '@/components/Pages/LandingPage';
import { firstQueryParam, sanitizePendingPrompt } from '@/lib/pendingPrompt';

export default function HomePage() {
  const searchParams = useLocalSearchParams();
  const pathname = usePathname();
  const token = useAuthStore(state => state.token);
  const isTokenExpired = useAuthStore(state => state.isTokenExpired);
  const q = sanitizePendingPrompt(firstQueryParam(searchParams.q));
  const appParams = q ? { q: firstQueryParam(searchParams.q) } : {};

  // Check if user is authenticated
  const isAuthenticated = token && !isTokenExpired();

  // The public stack can retain this screen behind the app after sign-in.
  // Its auth/query subscriptions must not launch redirects from the background.
  if (pathname !== '/') return null;

  // Authenticated users always land on the composer. Pass inbound ?q= only.
  if (isAuthenticated) {
    return <Redirect href={{ pathname: '/app', params: appParams }} />;
  }

  // Logged-out inbound prompts go to the public composer (send is still
  // auth-gated). Do not send them to the marketing landing page.
  if (q) {
    return <Redirect href={{ pathname: '/app', params: appParams }} />;
  }

  // If not authenticated, show the landing page
  return <LandingPage />;
}
